import React from "react";
import PropTypes from "prop-types";
import Badge from "../../../../components/common/Badge";

const StatusBadge = ({ isActive }) => (
  <Badge variant={isActive ? "success" : "error"}>
    {isActive ? "Active" : "Inactive"}
  </Badge>
);

StatusBadge.propTypes = {
  isActive: PropTypes.bool,
};

export default StatusBadge;
